import { Box, Typography } from '@mui/material'

export default function AboutSplitBlock({ label, children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: { xs: 2, md: 4 },
      }}
    >
      <Typography
        component="h3"
        sx={{
          fontSize: { xs: 22, md: 22 },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#000',
          flexShrink: 0,
        }}
      >
        {label}
      </Typography>
      <Box sx={{ width: { xs: '100%', md: 1000 }, maxWidth: 1000, flexShrink: 0 }}>
        {children}
      </Box>
    </Box>
  )
}
